export function normalizeImgSource(value: string | object): string {
  return typeof value === 'object' && value !== null && 'src' in value
    ? (value.src as string)
    : (value as string);
}
